<!---流水查询--->
<template>
  <div>
    <list
      row-key="ConsumeId"
      ref="list"
      unit="消费流水"
      :page="page"
      show-checkbox
      :query-params="params"
      :show-query="showQuery"
      :get-data-func="getDataFunc"
    >
      <template slot="toolbar-left">
        <span class="span-top-text" style="white-space: nowrap;">
          <span style="margin-right: 10px;">列表信息</span>
          <br v-if="isMB" />
          <span>合计金额: ￥{{Total}} 合计笔数 {{Count}}</span>
        </span>
      </template>
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="人员类别">
          <el-select v-model="params.MemberType" placeholder="请选择人员类别" clearable>
            <el-option label="学生" :value="0"></el-option>
            <el-option label="教职人员" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="人员编号">
          <el-input
            v-model="params.MemberNumber"
            :disabled="!active"
            placeholder="请输入人员编号"
            clearable
          />
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="params.MemberName" :disabled="!active" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="消费时间">
          <range-picker
            :date="[params.ConsumeStartDate,params.ConsumeEndDate]"
            @change="(x)=>{params.ConsumeStartDate=x.Start;params.ConsumeEndDate=x.End}"
            :clearable="false"
          />
        </el-form-item>
        <el-form-item label="餐次">
          <el-select v-model="params.MealName" placeholder="请选择餐次" clearable>
            <el-option v-for="(i,key) in Meals" :key="key" :label="i.MealName" :value="i.MealName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="餐补类型">
          <el-select v-model="params.MealType" clearable>
            <el-option label="在编在岗" value="在编在岗"></el-option>
            <el-option label="学生" value="学生"></el-option>
            <el-option label="物业" value="物业"></el-option>
            <el-option label="第三方" value="第三方"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model="params.DeviceName" placeholder="请输入设备名称" clearable />
        </el-form-item>
        <el-form-item label="设备位置">
          <el-input v-model="params.Place" placeholder="请输入设备位置" clearable />
        </el-form-item>
        <el-form-item label="记录方式">
          <el-select v-model="params.RecordWay" placeholder="请选择记录方式" clearable>
            <el-option label="系统" :value="0"></el-option>
            <el-option label="手工" :value="1"></el-option>
            <el-option label="对账" :value="2"></el-option>
            <el-option label="扫码" :value="3"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column label="人员编号" min-width="80px">
          <template slot-scope="{row}">
            <span v-if="row.MemberType==0">{{row.StudentNumber}}</span>
            <span v-else>{{row.TeacherNumber}}</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" min-width="80px">
          <template slot-scope="{row}">
            <span v-if="row.MemberType==0">{{row.StudentName}}</span>
            <span v-else-if="row.MemberType==1">{{row.TeacherName}}</span>
            <span v-else>临时人员</span>
          </template>
        </el-table-column>
        <el-table-column prop="CurrentGrade" label="年级" min-width="60px" />
        <el-table-column prop="CurrentClass" label="班级" min-width="80px" />
        <el-table-column prop="DpNames" label="部门" min-width="160px" />
        <el-table-column prop="ConsumeAmount" label="消费金额" min-width="90px" />
        <el-table-column prop="ConsumeTime" label="消费时间" min-width="140px" />
        <el-table-column prop="MealName" label="餐次" min-width="60px" />
        <el-table-column prop="MealType" label="餐补类型" align="center" min-width="80px" />
        <el-table-column prop="DeviceNo" label="消费设备编号" min-width="100px" />
        <el-table-column prop="DeviceName" label="消费设备名称" min-width="100px" />
        <el-table-column prop="Place" label="设备位置" min-width="160px" />
        <el-table-column prop="RecordWay" label="记录方式" align="center" min-width="80px">
          <div slot-scope="{row}">
            <span v-if="row.RecordWay==0">系统</span>
            <span v-else-if="row.RecordWay==1">手工</span>
            <span v-else-if="row.RecordWay==2">对账</span>
            <span v-else-if="row.RecordWay==3">扫码</span>
          </div>
        </el-table-column>
        <el-table-column prop="AddTeacherName" label="经办人" min-width="80px" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/cp/consume").default,
      meal_api: require("@/api/cp/meal").default,
      params: {
        MemberType: null,
        MemberNumber: "",
        MemberName: "",
        ConsumeStartDate: this.$commonJs.getToday(),
        ConsumeEndDate: this.$commonJs.getToday(),
        MealName: "",
        DeviceName: "",
        Place: "",
        RecordWay: null,
        MealType: null,
      },
      active: false,
      isMB: this.$store.state.isMB,
      Meals: [],
      Total: 0,
      Count: 0,
    };
  },
  watch: {
    "params.MemberType": {
      handler(val) {
        console.log("watch", val);
        if (val === null || val === "") {
          this.active = false;
        } else {
          this.active = true;
        }
        this.params.MemberNumber = "";
        this.params.MemberName = "";
      },
    },
  },
  mounted() {
    this.meal_api.list({}).then((res) => {
      this.Meals = res.Data;
    });
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.getTotalAmount(params).then((res) => {
          this.Total = res.Data;
        });
        this.api.list(params).then((res) => {
          this.Count = res.Count;
          resolve(res);
        });
      });
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      var params = this.$commonJs.obj.removeNullKey(this.params);
      this.api.export(params).then((res) => {
        loading.close();
      });
    },
    onDelete(row) {
      this.api.delete({ id: row.ConsumeId }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>